/* Shared React-Flow canvas styles. Injected on import so both the
   authenticated canvas editor and the public /replay/:token page render
   identical edges, handles, minimap, controls, and replay scrubber. */

const STYLE_ID = 'voxinity-flow-style';

const CSS = `
  /* ──────────────────────────────────────────────────────────
     Theme tokens — light vs dark. Applied via data-vox-theme on
     the canvas root so every node, edge, and chrome element
     adapts when the user toggles the app theme.
     ────────────────────────────────────────────────────────── */
  [data-vox-theme="dark"] {
    --vox-canvas-bg: #08090d;
    --vox-grid: rgba(255,255,255,0.06);
    --vox-node-bg: #0c0d12;
    --vox-node-bg-soft: rgba(255,255,255,0.03);
    --vox-node-border: rgba(255,255,255,0.10);
    --vox-text-primary: #ffffff;
    --vox-text-secondary: #9ca3af;
    --vox-text-muted: #6b7280;
    --vox-chrome-bg: #0c0d12;
    --vox-chrome-border: rgba(255,255,255,0.08);
    --vox-handle-ring: #08090d;
    --vox-label-bg: #0c0d12;
  }
  [data-vox-theme="light"] {
    --vox-canvas-bg: #f8fafc;
    --vox-grid: rgba(15,23,42,0.08);
    --vox-node-bg: #ffffff;
    --vox-node-bg-soft: rgba(15,23,42,0.025);
    --vox-node-border: rgba(15,23,42,0.10);
    --vox-text-primary: #0f172a;
    --vox-text-secondary: #475569;
    --vox-text-muted: #94a3b8;
    --vox-chrome-bg: #ffffff;
    --vox-chrome-border: rgba(15,23,42,0.08);
    --vox-handle-ring: #ffffff;
    --vox-label-bg: #ffffff;
  }

  .voxinity-flow .react-flow__attribution { display: none; }
  /* Per-edge stroke is driven by inline style on each edge (see
     edgeDecorator.js) so handle/wire/label all share one color. */
  .voxinity-flow .react-flow__edge-path { stroke-width: 2; }
  .voxinity-flow .react-flow__edge.selected .react-flow__edge-path { stroke-width: 3; filter: drop-shadow(0 0 6px currentColor); }
  /* Slower, lighter dash so the wires feel calm not frantic */
  .voxinity-flow .react-flow__edge.animated .react-flow__edge-path { stroke-dasharray: 4 6; animation: voxFlowDash 1.6s linear infinite; }
  .voxinity-flow .react-flow__edge { z-index: 10 !important; }
  .voxinity-flow .react-flow__edge-textbg { rx: 4; }
  @keyframes voxFlowDash { from { stroke-dashoffset: 10; } to { stroke-dashoffset: 0; } }
  .voxinity-flow .react-flow__handle { transition: scale 0.15s, box-shadow 0.15s; }
  .voxinity-flow .react-flow__handle:hover { scale: 1.35; box-shadow: 0 0 0 5px rgba(45,212,191,0.22); }
  .voxinity-flow .vox-handle-out { width: 14px; height: 14px; border: 2px solid var(--vox-handle-ring); cursor: crosshair; }
  .voxinity-flow .vox-handle-in { width: 46px; height: 10px; border-radius: 6px; border: 2px solid var(--vox-handle-ring); background: rgba(148,163,184,0.6); }
  .voxinity-flow .react-flow__handle.connectingto, .voxinity-flow .react-flow__handle.valid { background: #2dd4bf !important; box-shadow: 0 0 0 6px rgba(45,212,191,0.3); }
  .voxinity-flow .react-flow__connection-path { stroke: #2dd4bf; stroke-width: 2.5; stroke-dasharray: 5 5; }
  .voxinity-flow .react-flow__edge-interaction { cursor: pointer; }
  .voxinity-flow .react-flow__minimap { background: var(--vox-chrome-bg); border: 1px solid var(--vox-chrome-border); border-radius: 8px; opacity: 0.95; }
  .voxinity-flow .react-flow__controls { box-shadow: none; }
  .voxinity-flow .react-flow__controls button { background: var(--vox-chrome-bg); border-color: var(--vox-chrome-border); color: var(--vox-text-secondary); }
  .voxinity-flow .react-flow__controls button:hover { background: rgba(45,212,191,0.12); }
  .voxinity-replay-scrubber { -webkit-appearance: none; appearance: none; height: 4px; background: rgba(255,255,255,0.08); border-radius: 999px; outline: none; }
  .voxinity-replay-scrubber::-webkit-slider-thumb { -webkit-appearance: none; appearance: none; width: 14px; height: 14px; border-radius: 50%; background: #2dd4bf; cursor: pointer; box-shadow: 0 0 0 3px rgba(45,212,191,0.25); transition: transform 0.12s; }
  .voxinity-replay-scrubber::-webkit-slider-thumb:hover { transform: scale(1.15); }
  .voxinity-replay-scrubber::-moz-range-thumb { width: 14px; height: 14px; border: 0; border-radius: 50%; background: #2dd4bf; cursor: pointer; box-shadow: 0 0 0 3px rgba(45,212,191,0.25); }
`;

if (typeof document !== 'undefined' && !document.getElementById(STYLE_ID)) {
  const s = document.createElement('style');
  s.id = STYLE_ID;
  s.textContent = CSS;
  document.head.appendChild(s);
}

export {};
